<template>
  <div class="body" style="border: 10px solid #edeff2">
    <a-spin :spinning="spin">
      <div class="title">
        <div class="font">
          首页模版列表
          <a-alert style="height: 40px;margin-top: 5px;margin-left: 10px"  type="info" show-icon size="small" >
            <span slot="message" style="font-weight: normal">增值服务：如需代搭建微网站、设计KV/海报、会议直播等服务，请点击右侧咨询客服</span>
          </a-alert>
        </div>
        <div style="display: flex;height: 35px;line-height: 35px;width:320px;margin-top: 7px">
          <div>会议状态：</div>
          <a-radio-group v-model="liveStatus" button-style="solid" @change="liveStatusChange">
            <a-radio-button value="">
              全部
            </a-radio-button>
            <a-radio-button value="free">
              免费
            </a-radio-button>
            <a-radio-button value="paid">
              付费
            </a-radio-button>
          </a-radio-group>
        </div>
      </div>
      <div>
        <!--        <div class="item" v-for="item in datasource" :key="item.id">-->
        <!--          <div>-->
        <!--            <a-tag-->
        <!--              :color="item.name === '模版一（九宫格）'?'green':item.name === '模版二（方块格）'?'blue':''"-->
        <!--              class="tag"-->
        <!--            >{{ item.name }}</a-tag>-->
        <!--&lt;!&ndash;            <a-tag&ndash;&gt;-->
        <!--&lt;!&ndash;              color="blue"&ndash;&gt;-->
        <!--&lt;!&ndash;              class="tag"&ndash;&gt;-->
        <!--&lt;!&ndash;              v-if="item.name === '模版二（方块格）'"&ndash;&gt;-->
        <!--&lt;!&ndash;            >&ndash;&gt;-->
        <!--&lt;!&ndash;              {{ item.name }}&ndash;&gt;-->
        <!--&lt;!&ndash;            </a-tag>&ndash;&gt;-->
        <!--          </div>-->
        <!--          &lt;!&ndash; 图片 &ndash;&gt;-->
        <!--          <div style="width: 100%; height: 88%; padding: 35px 20px 15px 20px">-->
        <!--            <img :src="item.egImg" style="width: 100%; height: 100%" />-->
        <!--          </div>-->

        <!--          &lt;!&ndash; 按钮  &ndash;&gt;-->
        <!--          <div class="btn">-->
        <!--            <a-->
        <!--              :href="item.operateVideo"-->
        <!--              target="_blank"-->
        <!--              v-show="item.operateVideo"-->
        <!--            >-->
        <!--              <a-button type="primary" class="btnone">-->
        <!--                <a-icon-->
        <!--                  type="play-circle"-->
        <!--                  theme="twoTone"-->
        <!--                  style="font-size: 20px; vertical-align: middle"-->
        <!--                />-->
        <!--                操作视频-->
        <!--              </a-button>-->
        <!--            </a>-->
        <!--            <a-->
        <!--              :href="item.operateFile"-->
        <!--              target="_blank"-->
        <!--              v-show="item.operateFile"-->
        <!--            >-->
        <!--              <a-button type="primary" class="btntwo">-->
        <!--                <a-icon-->
        <!--                  type="file-pdf"-->
        <!--                  theme="twoTone"-->
        <!--                  style="font-size: 20px; vertical-align: middle"-->
        <!--                />-->
        <!--                操作文档-->
        <!--              </a-button>-->
        <!--            </a>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <a-row>
        <!-- 空数据 -->
        <div v-if="datasource.length == 0">
          <NullDataPrompt message="暂无数据"></NullDataPrompt>
        </div>
        <a-col
          @click="openLive(item)"
          v-else
          :span="innerWidths > 0 && innerWidths < 1920 ? 5 : 4"
          style="margin-bottom: 2%"
          v-for="item in datasource"
          :key="item.id"
        >
          <div
            :style="{
              width: innerWidths > 0 && innerWidths < 1920 ? '92%' : '90%',
            }"
            class="iconSty"
          >
            <div class="img">
              <img :src="item.egImg" style="width: 100%" />
              <div>
                <a-tag :color="item.name === '模版一（九宫格）'?'green':item.name === '模版二（方块格）'?'blue':''" class="tag">{{ item.name }}</a-tag>
              </div>
              <img v-if="item.mode === 'free'" class="pitchOn" src="../../../assets/paidImg/free.png">
              <img v-if="item.mode === 'paid'" class="pitchOn" src="../../../assets/paidImg/paid.png">
              <!-- 遮罩层 -->
              <div class="box-y">
                <div>
<!--                  <admin_con style="font-size: 40px" type="icon-xuanze" />-->
                  <p
                    style="
                      color: white;
                      margin: 20px 0px 0px -13px;
                      font-size: 17px;
                      font-weight: 550;
                    "
                  >
                    使用模版
                  </p>
                </div>
              </div>
            </div>
<!--            <div class="btn">-->
<!--              <a-button-->
<!--                type="primary"-->
<!--                v-show="item.operateFile"-->
<!--                @click="openLink(item.operateFile)"-->
<!--              >-->
<!--                &lt;!&ndash;                <a-icon&ndash;&gt;-->
<!--                &lt;!&ndash;                    type="file-pdf"&ndash;&gt;-->
<!--                &lt;!&ndash;                    theme="twoTone"&ndash;&gt;-->
<!--                &lt;!&ndash;                    style="font-size: 20px; vertical-align: middle;margin-left:-8px"&ndash;&gt;-->
<!--                &lt;!&ndash;                />&ndash;&gt;-->
<!--                <admin_con-->
<!--                  style="-->
<!--                    font-size: 20px;-->
<!--                    vertical-align: middle;-->
<!--                    margin-left: -8px;-->
<!--                  "-->
<!--                  type="icon-PSD"-->
<!--                />-->
<!--                下载素材（psd）-->
<!--              </a-button>-->
<!--              &lt;!&ndash;              <a-button&ndash;&gt;-->
<!--              &lt;!&ndash;                type="primary"&ndash;&gt;-->
<!--              &lt;!&ndash;                v-show="item.operateVideo"&ndash;&gt;-->
<!--              &lt;!&ndash;                @click="openLink(item.operateVideo)"&ndash;&gt;-->
<!--              &lt;!&ndash;                style="width: 48%"&ndash;&gt;-->
<!--              &lt;!&ndash;              >&ndash;&gt;-->
<!--              &lt;!&ndash;                <a-icon&ndash;&gt;-->
<!--              &lt;!&ndash;                  type="play-circle"&ndash;&gt;-->
<!--              &lt;!&ndash;                  theme="twoTone"&ndash;&gt;-->
<!--              &lt;!&ndash;                  style="font-size: 20px; vertical-align: middle;margin-left:-8px"&ndash;&gt;-->
<!--              &lt;!&ndash;                />&ndash;&gt;-->
<!--              &lt;!&ndash;                操作视频&ndash;&gt;-->
<!--              &lt;!&ndash;              </a-button>&ndash;&gt;-->
<!--              &lt;!&ndash;              &ensp;&ndash;&gt;-->
<!--              &lt;!&ndash;              <a-button&ndash;&gt;-->
<!--              &lt;!&ndash;                type="primary"&ndash;&gt;-->
<!--              &lt;!&ndash;                v-show="item.operateFile"&ndash;&gt;-->
<!--              &lt;!&ndash;                @click="openLink(item.operateFile)"&ndash;&gt;-->
<!--              &lt;!&ndash;                style="width: 48%"&ndash;&gt;-->
<!--              &lt;!&ndash;              >&ndash;&gt;-->
<!--              &lt;!&ndash;                <a-icon&ndash;&gt;-->
<!--              &lt;!&ndash;                  type="file-pdf"&ndash;&gt;-->
<!--              &lt;!&ndash;                  theme="twoTone"&ndash;&gt;-->
<!--              &lt;!&ndash;                  style="font-size: 20px; vertical-align: middle;margin-left:-8px"&ndash;&gt;-->
<!--              &lt;!&ndash;                />&ndash;&gt;-->
<!--              &lt;!&ndash;                操作文档&ndash;&gt;-->
<!--              &lt;!&ndash;              </a-button>&ndash;&gt;-->
<!--            </div>-->
          </div>
        </a-col>
      </a-row>
      <!-- <a-pagination v-model:current="curPage" :total="total" show-less-items /> -->
      <div
        style="
          display: block;
          width: 100%;
          height: 50px;
          text-align: center;
          margin-top: 5px;
        "
      >
        <a-pagination
          :current="curPage"
          :total="total"
          :pageSize="pageSize"
          show-less-items
          @change="PageNOchange"
          style="display: inline-block"
        />
      </div>
      <MessageAlert
        :visible="visibleAlert"
        v-on:closeMain="closeMainAlert"
      ></MessageAlert>
    </a-spin>
  </div>
</template>

<script>
import variables from "@/assets/base.scss";
import { getPage } from "../../../service/columnmanageapi";
import NullDataPrompt from "../../../components/NullDataPrompt.vue";
import { admin_icon } from "@/utils/myIcon";
import { getAuthenticationInformation } from "@/service/authentication";
import MessageAlert from "@/components/Authentication/MessageAlert";

export default {
  name: "pageManagement",
  components: { NullDataPrompt, admin_con: admin_icon, MessageAlert },
  data() {
    return {
      visibleAlert: false,
      variables,
      datasource: [],
      spin: false,
      innerWidths: null,
      curPage: 1,
      total: 0,
      pageSize: 10,
      userInfoList: {},
      liveStatus:'',
      // pageSize: innerWidths > 0 && innerWidths < 1920 ? 10 : 12,
    };
  },
  created() {
    this.innerWidths = window.innerWidth; //屏幕宽度
    (this.pageSize = this.innerWidths > 0 && this.innerWidths < 1920 ? 10 : 12),
      this.load();
    this.getInformation();
  },
  methods: {
    async getInformation() {
      const response = await getAuthenticationInformation();
      if (response.code === 200) {
        this.userInfoList = response.data;
      } else {
        this.$message.warning("name", response.message);
      }
    },
    liveStatusChange(){
      this.load();
    },
    load() {
      this.spin = true;
      getPage({
        isOpen: 1,
        mode:this.liveStatus,
        curPage: this.curPage,
        pageSize: this.pageSize,
      }).then((res) => {
        this.datasource = res.data;
        this.total = res.count;
        this.spin = false;
      });
    },
    openLink(url) {
      window.open(url);
    },
    // 改变页码
    PageNOchange(curPage) {
      this.curPage = curPage;
      this.load();
    },
    openLive(item) {
      // 判断当前是否认证   0,//认证状态 0-未提交认证 1已提交待审核 2已审核未通过 3已通过审核
      // if (this.userInfoList.memberStatus !== 0) {
      //   this.$store.dispatch("isShowNav", false); //导航栏
      //   this.$router.push({
      //     path: "meeting",
      //     query: { selectId: item.id, isShowIconTitle: item.isShowIconTitle },
      //   });
      //   sessionStorage.setItem("pageParams", JSON.stringify(item));
      // } else {
      //   this.visibleAlert = true;




      // if (!this.userInfoList.id) {
      //   this.visibleAlert = true;
      // }else {
      //   this.$store.dispatch("isShowNav", false); //导航栏
      //   this.$router.push({
      //     path: "meeting",
      //     query: { selectId: item.id, isShowIconTitle: item.isShowIconTitle },
      //   });
      //   sessionStorage.setItem("pageParams", JSON.stringify(item));
      // }
    },
    closeMainAlert(val) {
      this.visibleAlert = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-col-5 {
  width: 20%;
}
.ant-col-4 {
  width: 16.666%;
}
body {
  width: 100%;
  min-height: 600px;
  height: 100%;
  .tag {
    position: absolute;
    left: 5px;
    top: 5%;
  }
  .title {
    border-bottom: 1px solid #edeff2;
    height: 50px;
    line-height: 50px;
    margin-bottom: 15px;
    display: flex;justify-content: space-between;
    padding-left: 1%;
    .font {
      display: flex;
      font-weight: 600;
      color: $topNameColor;
      width: $space_div;
      margin: auto;
    }
  }
  .iconSty {
    border: 1px solid #edeff2;
    margin: auto;
    height: 400px;
    border-radius: 10px;
    //cursor: pointer;
    .img {
      width: 90%;
      margin: auto;
      height: 96%;
      display: flex;
      justify-content: center;
      padding-top: 5%;
      position: relative;
      // background-color: rebeccapurple;
    }
    .pitchOn{
      position: absolute;
      top: 0;
      right: -14px;
      width: 60px;
      height: auto;
      z-index: 99999;
    }
    .btn {
      width: 90%;
      margin: auto;
      display: flex;
      margin-top: 2.5%;
      justify-content: center;
    }
  }
}
.box-y {
  position: absolute;
  padding-top: 5%;
  left: 0;
  width: 100%;
  height: 95%;
  background: rgba(0, 0, 0, 0.4) no-repeat center;
  display: none;
}
.img:hover .box-y {
  display: block;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

//.ant-spin-nested-loading {
//  width: 100%;
//  min-height: 600px;
//}
//.item {
//  position: relative;
//  width: 23%;
//  aspect-ratio: 1/1.1;
//  // float: left;
//  display: inline-block;
//  border: 1.3px solid #edeff2;
//  border-radius: 8px;
//  margin-left: 16px;
//  margin-bottom: 15px;
//  .tag {
//    z-index: 99;
//    position: absolute;
//    top: 3px;
//    right: 5px;
//    //width: 50%;
//    text-align: center;
//  }
//  img {
//    width: 100%;
//    height: 100%;
//    // object-fit: cover;
//    // padding: 10px;
//  }
//
//  a-icon {
//    font-size: 20px;
//    vertical-align: middle;
//  }
//}
//
//a {
//  color: white;
//}
//.btn {
//  position: absolute;
//  bottom: 10px;
//  width: 100%;
//  height: 10%;
//  display: flex;
//  // background: palegreen;
//  a {
//    margin: auto;
//    width: 45%;
//    height: 100%;
//
//    // background: red;
//  }
//  .btnone {
//    width: 100%;
//    height: 100%;
//    font-size: 14px;
//    text-align: right;
//  }
//  .btntwo {
//    width: 100%;
//    height: 100%;
//    font-size: 14px;
//    text-align: right;
//  }
//}
</style>
